<template>
  <div style="overflow-y: auto; overflow-x: hidden" class="campaigns-container">
    <mf-search v-model="search" hide-details placeholder="Busque por campanhas" />

    <paginated-data-table
      :headers="headers"
      :search="search"
      :query="query"
      :custom-items-per-page="10"
      :query-variables="queryVariables"
      :graphql-uri="$microservicesUrls['benefitsManager']"
      query-name="findPaginatedBenefits"
      query-main-property-name="benefits"
      use-input-param
    >
      <template #item="{ item }">
        <tr class="cursor-pointer" @click="toggleCampaign(item)">
          <td>
            <v-simple-checkbox :value="selectedCampaignsIds.includes(item._id)" color="primary" :ripple="false" @input="toggleCampaign(item)" />
          </td>
          <td class="nowrap-row">
            {{ getStatusLabel(item.status).text }}
          </td>
          <td class="nowrap-row">
            <v-tooltip max-width="250" top content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <a class="link" @click="link(item._id)">
                    {{ item.title }}
                  </a>
                </span>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </td>
          <td class="nowrap-row">
            <v-tooltip :disabled="!item.description" max-width="250" top content-class="truncated-tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ (item.description || '-') | truncate({ length: 150 }) }}</span>
              </template>
              <span>{{ item.description || '-' }}</span>
            </v-tooltip>
          </td>
          <td class="coupon-name">{{ item.code | hifen }}</td>
          <td>{{ item.units.length === 1 ? '1 loja' : `${item.units.length} lojas` }}</td>
          <td>{{ item.productsEnabled ? 'Sim' : 'Não' }}</td>
          <td>{{ getPeriod(item.startDate, item.expiresAt) }}</td>
        </tr>
      </template>
    </paginated-data-table>
  </div>
</template>

<script>
import { getStatusLabel, getPeriod } from '@/config/helpers.js'
import { QUERY_FIND_BENEFITS } from '../../../graphql'

import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
export default {
  name: 'SelectBenefitsTable',
  components: {
    PaginatedDataTable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    singleCheckbox: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
  },
  data: () => ({
    search: '',
    selectedCampaignsIds: [],
  }),
  computed: {
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    query() {
      return QUERY_FIND_BENEFITS
    },
    queryVariables() {
      return {
        status: this.status.map((status) => status.toUpperCase()),
        franchise: this.isFranchise || this.isFranchisee,
      }
    },
    headers() {
      return [
        {
          text: '',
          value: '_id',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          width: '100px',
        },
        {
          text: 'Nome',
          value: 'title',
          width: '18%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '18%',
        },
        {
          text: 'Cupom',
          value: 'code',
          width: '10%',
        },
        {
          text: 'Lojas',
          value: 'units',
          width: '90px',
          sortable: false,
        },
        {
          text: 'Produtos vigentes',
          value: 'products',
          width: '175px',
        },
        {
          text: 'Data de validade',
          value: 'expiresAt',
          width: '24%',
        },
      ]
    },
    selectedCampaigns: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    selectedCampaigns: {
      deep: true,

      handler(value) {
        this.selectedCampaignsIds = value.map(({ _id }) => _id)
      },
    },
  },
  mounted() {
    if (this.selectedCampaigns) this.selectedCampaignsIds = this.selectedCampaigns.map(({ _id }) => _id)
  },
  methods: {
    getStatusLabel,
    getPeriod,
    toggleCampaign(toggledCampaign) {
      if (this.singleCheckbox) {
        this.selectedCampaigns = [toggledCampaign]
        return
      }
      const selectedCampaignsDelta = this.selectedCampaigns.filter((campaign) => campaign._id !== toggledCampaign._id)

      if (selectedCampaignsDelta.length === this.selectedCampaigns.length) {
        selectedCampaignsDelta.push(toggledCampaign)
      }
      this.selectedCampaigns = selectedCampaignsDelta
    },
    link(benefit_id) {
      const route = this.$router.resolve({ path: `/campanhas/cupom-desconto/resultados/${benefit_id}` })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.campaigns-container {
  max-height: 70vh !important;
}
</style>
